import styled from 'vue-styled-components'

const ScrollView = styled('div', ['height', 'width', 'padding'])`
  overflow: auto;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  padding: ${(props) => props.padding};
`

export { ScrollView }
